import Vue from 'vue';
import Router from 'vue-router';
import OnboardForm from '../onboard/OnboardForm.vue';

Vue.use(Router);

const DEFAULT_TITLE = 'e-Banking customer onboarding';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/onboard/:countryCode/:languageCode',
      name: 'onboard',
      component: OnboardForm,
      props: true,
      meta: {
        title: 'e-Banking customer onboarding',
        metaTags: [
          {
            name: 'description',
            content: 'ProCredit e-Banking customer onboarding',
          },
        ],
      },
    },
    {
      path: '/onboard/:countryCode/',
      redirect: '/onboard/:countryCode/en',
    },
    {
      path: '/onboard/',
      redirect: '/',
    },
  ],
});

router.afterEach((to) => {
  document.title = to.meta.title || DEFAULT_TITLE;
});
export default router;
